import React from "react";
import { ITEM_MENU_ACTIONS } from "../../../data/StringConstants";
import { Permissions } from "../../../data/Permissions";
import SendIcon from '@material-ui/icons/Send';
import SendOutlinedIcon from '@material-ui/icons/SendOutlined';
import { Share, ViewCarousel } from "@material-ui/icons/";


/**
 * Push 'add to widget' menu item onto object of available actions (share action section)
 * 
 * @param {object} availableActions - the default menu actions for an item 
 * @param {object} item - the current item for which the menu is being created
 */
export function pushAddToWidgetMenuItem(availableActions, item) {
    let transformedActions = availableActions;
    transformedActions.shareActions.push({
        label: ITEM_MENU_ACTIONS.ADD_TO_WIDGET,
        icon: <ViewCarousel />,
        permissions: [Permissions.publisher],
        target: item.WidgetUrl,
        noNewTab: true
    });

    return transformedActions;
}

/**
 * Push 'send email' and 'send test email' menu items onto object of available actions (share action section)
 * 
 * @param {object} availableActions - the default menu actions for an item 
 * @param {object} item - the current item for which the menu is being created
 */
export function pushSendEmailMenuItems(availableActions, item) {
    let transformedActions = availableActions;
    transformedActions.shareActions.push({
        label: ITEM_MENU_ACTIONS.SEND_EMAIL,
        icon: <SendIcon />,
        permissions: [Permissions.publisher],
        target: item.EmailUrl,
        noNewTab: true
    },
    {
        label: ITEM_MENU_ACTIONS.SEND_TEST_EMAIL,
        icon: <SendOutlinedIcon />,
        permissions: [Permissions.publisher],
        target: item.TestEmailUrl,
        noNewTab: true
    });
    
    return transformedActions;
}

/**
 * Update print action target to point to thumbnail download url (necessary for web items in LA)
 * 
 * @param {object} availableActions - the default menu actions for an item 
 * @param {object} item - the current item for which the menu is being created
 */
export function updatePrintTargetForWebItem(availableActions, item) {
    let transformedActions = availableActions;
    transformedActions.viewActions.find(x => x.label === ITEM_MENU_ACTIONS.PRINT).target = item.ThumbnailDownloadUrl;

    return transformedActions;
}

/**
 * Remove 'view pdf' menu action. 
 * 
 * @param {object} availableActions - the default menu actions for an item 
 * @param {object} item - the current item for which the menu is being created
 */
export function removeViewPdfMenuItem(availableActions) {
    let transformedActions = availableActions;
    transformedActions.viewActions = transformedActions.viewActions.filter(x => x.label !== ITEM_MENU_ACTIONS.VIEW_PDF);

    return transformedActions;
}

export function addInstagramIconToItemCardMenuAfterFacebookIcon(shareActions, action) {
	var facebookShareActionIndex = shareActions.findIndex(x => x.label == ITEM_MENU_ACTIONS.FACEBOOK);
	shareActions.splice(facebookShareActionIndex + 1, 0, action);
	return shareActions;
}
